<a (click)="skipToMain($event)" href="#main" class="skip-link t-body-large"
  >Skip to main content</a
>
<app-header />
<main class="main" id="main" tabindex="-1">
  @if (showDevOnly) {
    <app-dev-overlay
      (logout)="this.authService.logout('User Logout from DevOverlayComponent')"
      (validate)="this.authService.validateToken()" />
  }
  <router-outlet />
  @if (this.isAuthenticated()) {
    <app-paperless-billing-modal />
  }
</main>
<app-footer />
